import { mediaUrl } from "./imageUtils";
/**
 * Utility functions extracted from About.tsx, Contact.tsx, Author.tsx, Archive.tsx, and TabThree.tsx
 */

/**
 * Sanitize about data, extracting 5 fields with "" defaults
 */
export function sanitizeAbout(about: Record<string, unknown>): {
  superHeadingOne: string;
  headingOne: string;
  textOne: string;
  headingTwo: string;
  textTwo: string;
} {
  return {
    superHeadingOne: (about.superHeadingOne as string) || "",
    headingOne: (about.headingOne as string) || "",
    textOne: (about.textOne as string) || "",
    headingTwo: (about.headingTwo as string) || "",
    textTwo: (about.textTwo as string) || "",
  };
}

/**
 * Sanitize contact data, extracting contact fields with defaults
 */
export function sanitizeContact(contact: Record<string, unknown>): {
  superHeading: string;
  heading: string;
  text: unknown;
  phone: string;
  email: string;
  address: unknown;
  formText: unknown;
  latitude: number;
  longitude: number;
  mapZoom: number;
} {
  return {
    superHeading: (contact.superHeading as string) || "",
    heading: (contact.heading as string) || "",
    text: contact.text || [],
    phone: (contact.phone as string) || "",
    email: (contact.email as string) || "",
    address: contact.address || [],
    formText: contact.formText || { image: [] },
    latitude: (contact.latitude as number) || 0,
    longitude: (contact.longitude as number) || 0,
    mapZoom: (contact.mapZoom as number) || 0,
  };
}

/**
 * Get author image URL from nested Strapi formats
 */
export function getAuthorImageUrl(
  image:
    | {
        formats?: Record<string, { url: string }>;
      }
    | undefined,
  format: string,
  siteUrl: string
): string {
  return image?.formats?.[format]?.url
    ? mediaUrl(image.formats[format].url, siteUrl)
    : "";
}

/**
 * Find archive background image by section (case-insensitive)
 */
export function findArchiveBackgroundImage(
  images: Array<{ section?: string }>,
  section: string
): { section?: string } | null {
  return (
    images.find(
      (item) =>
        item.section?.toLowerCase() === section.toLowerCase()
    ) ?? null
  );
}

/**
 * Initialize viewport with coordinates, returning viewport and error state
 */
export function initializeViewport(
  lat: number,
  lng: number,
  zoom: number
): { viewport: Record<string, number>; error: string | null } {
  if (lat && lng) {
    return {
      viewport: { latitude: lat, longitude: lng, zoom },
      error: null,
    };
  }
  return {
    viewport: {},
    error: "Error loading map: Latitude and longitude not provided.",
  };
}

/**
 * Label items with a type string
 */
export function labelItems<T>(
  items: T[],
  type: string
): Array<T & { type: string }> {
  return items.map((item) => ({ ...item, type }));
}
